import React, { useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { MultiSelectField } from 'components/SelectField/MultiSelectField.js';
import ModalDialog from '../../../../../components/ModalDialog/ModalDialog.js';
import { ExportSitesByType } from '../../../actions/SiteTrackerActions';

const SiteTrackerOptionsDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const userId = useSelector(state => state.session.user.id);

	const phases = [ { text: 'NNS', value: 'NNS' },
		 { text: 'Nokia NNS', 	value: 'Nokia NNS' 	 },
		 { text: 'Rollout PH1', value: 'Rollout PH1' },
		 { text: 'Rollout PH2', value: 'Rollout PH2' },
		 { text: 'Rollout PH3', value: 'Rollout PH3' },
		 { text: 'Rollout BAU', value: 'Rollout BAU' },
		 { text: 'VMO2', value: 'VMO2' },
		 { text: 'NNS CWP', value: 'NNS CWP' } ];

	const [phase, setPhase] = useState([]); 
	
	const handlePhaseChange = (value) => {
		if (value.length > 0 && value.length === phases.length) {
			setPhase(['All']);
		} else {
			setPhase(value);
		}
	};

	const renderSelected = (selected) => {
		if (selected.length > 0 && selected.length === phases.length) {
			return 'All';
		}
		return selected.join(', ');
	};

	const _onConfirmClick = () => {
		dispatch(ExportSitesByType(userId, phase.join(',')));
	};

	return (
		<ModalDialog
			maxWidth="xs"
			onClose={onClose}
			open={open}
			title="Options"
			confirmLabel="Export"
			onConfirmClicked={_onConfirmClick}
			cancelLabel="Close"
		>
			<div
				style={{ marginTop: '10px' }}
			>
				<MultiSelectField
					id="phase"
					name="phase"
					hintText="Phase"
					menuItems={phases}
					onListChange={handlePhaseChange}
					renderValue={renderSelected}
					selectAll
				/>
			</div>
		</ModalDialog>
	);
};

SiteTrackerOptionsDialog.propTypes = {
	author: PropTypes.object,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool,
};

export default SiteTrackerOptionsDialog;
